export class ShoppingList {
    /**
     * Remove items from the shopping list
     *
     * @param elements
     * @param originList
     */
    static removeItemsFromShoppingList = (elements: HTMLElement[] | string, originList: HTMLElement = undefined): void => {
        const identifiers = [];

        const list: HTMLElement = originList !== undefined
            ? originList
            : Array.isArray(elements)
                ? ShoppingList.getShoppingList(elements[0])
                : undefined;

        if (list === undefined) {
            return;
        }

        const removeLink = list.dataset.removelink;
        const resetLink = list.dataset.removeItemsUrl;
        const updateSummary = list.dataset.updateSummary ?? 'true';
        let url = resetLink;

        if (Array.isArray(elements)) {
            elements.forEach((element) => {
                identifiers.push(element.dataset.identifier);
            });

            url = removeLink;
        }

        const request = (url: string, identifiers: string[]) => {
            list.style.opacity = '0.15';

            const loadingIndicator = list.parentElement.querySelector('.loading-indicator');
            if (loadingIndicator) {
                loadingIndicator.classList.remove('d-none');
            }

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    identifiers: identifiers
                })
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    list.style.opacity = '1';

                    if (loadingIndicator) {
                        loadingIndicator.classList.add('d-none');
                    }

                    if (list.dataset.queryErp) {
                        $(list).erpShoppingBasket('loadBasket');
                    }

                    if (data) {
                        window.updateCartPreviewCount(data);
                    }

                    if (updateSummary !== 'false') {
                        window.reloadSummary(list);
                        window.updateCheckoutButtons(data.checkout.hasNormalItems, data.checkout.hasRequestItems);
                        window.toggleShoppingCarts(list, data.checkout.hasNormalItems, data.checkout.hasRequestItems);
                    }

                    window.updateAnnotations();

                    if (Array.isArray(elements)) {
                        elements.forEach((element) => {
                            const parent = element.parentElement;

                            const pharmaceuticalsWarning = parent.querySelector('.pharmaceuticalsWarning');
                            if (pharmaceuticalsWarning) {
                                pharmaceuticalsWarning.remove();
                            }

                            const nwdTableListItem = element.closest('.nwd-table__list-item');
                            if (nwdTableListItem) {
                                nwdTableListItem.remove();
                            }

                            element.remove();
                        });
                    } else if (elements === 'all') {
                        const productListItems = list.querySelectorAll('.product-list-item');
                        productListItems.forEach((productListItem) => {
                            productListItem.remove();
                        });

                        const pharmaceuticalsWarnings = list.querySelectorAll('.pharmaceuticalsWarning');
                        pharmaceuticalsWarnings.forEach((pharmaceuticalsWarning) => {
                            pharmaceuticalsWarning.remove();
                        });

                    }

                    const productListItems = list.querySelectorAll('.product-list-item');
                    if (productListItems.length === 0) {
                        const emptyNotice: HTMLElement = list.querySelector('.empty-list-notice');
                        if (emptyNotice) {
                            emptyNotice.style.display = null;
                        }
                    }
                })
                .then(() => {
                    ShoppingList.updatePositions(list);
                })
                .catch((error) => {
                    console.error('Error (removing item from list):', error);
                });
        }

        request(url, identifiers);
    }

    /**
     * Get the shopping list
     */
    static getShoppingList = (listItem: HTMLElement): HTMLElement => {
        return listItem.dataset.listRef
            ? document.querySelector('[data-list-id="' + listItem.dataset.listRef + '"][data-removelink]')
            : listItem.closest('[data-removelink]');
    }

    /**
     * Get list element for a list item element
     *
     * @param list
     */
    static getListSummaryElement = (list: HTMLElement): HTMLElement => {
        return list.querySelector('.shopping-list-totals');
    }

    /**
     * Get closest list item element
     *
     * @param element
     */
    static getListItemElement = (element: HTMLElement): HTMLElement => {
        return element.closest('[data-identifier]');
    }

    /**
     * Update the positions of the list items in the list
     *
     * @param list
     */
    static updatePositions = (list: HTMLElement): void => {
        const items = list.querySelectorAll('[data-plandent-checkout-item]');
        let i = 1;
        items.forEach((item, index) => {
            const positionItem = item.querySelector('[data-plandent-shopping-list-data="position"]')
            if (!positionItem) {
                return;
            }

            positionItem.textContent = String(i).padStart(2, '0') + '.';
            i++;
        });
    }
}
